import { Breadcrumbs, Button, Grid, Link } from "@mui/material";
import React, { useRef, useState } from "react";
import Styles from "../../Style/Main.module.css";
import logo from "../../../../images/Group 1000000833.png";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import UploadTable from "./UploadTable";
import Select from "@mui/material/Select";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Dialog } from "@mui/material";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../../Loader/Loader";
import { useStateValue } from "../../../../Hooks/stateProvider";
import UploadAction from "../../../CommonLayouts/UploadAction";
import { encrypt } from "../../../../utils/cipher";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { KEY, ls } from "../../../../variables";
import { Year, Quarter } from "../../../../variables";
import SelectComponent from "../../../../components/SelectComponent"
import { errorHandler } from "../../../../utils/errorHandling";
import { alert } from "../../../../utils/sweetAlert";
import { previewValidators } from "../../../../utils/validators";

const SebiUploadUtility = () => {
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const isPreviewClicked = useRef(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleUpload = () => {
    if (!previewValidators(selectedFinancialYear, selectedQuarter, false, "", dispatch, "empty")) {
      return;
    }
    setOpen(true);
  };
  let s3LocationArr = [];
  const [disableBtn, setDisableBtn] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [{ fileName, fileDetails }, dispatch] = useStateValue();
  const [rows, setRows] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [uploadData, setUploadData] = useState();
  const navigate = useNavigate();
  const handlePreviewClose = () => {
    setPreviewOpen(false);
  };

  const handelDownload = async (s3Path) => {
    dispatch({ type: "SHOW_LOADER" });
    isPreviewClicked.current = true;
    const payload = {
      s3Location: s3Path,
      moduleType: "ALERT",
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken")
    };

    const encryptedPayload = await encrypt(payload);
    axios
      .post(
        "/api/pms/downloadReport",
        {
          payload: encryptedPayload,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res) {
          window.open(res.data.data, "_self");
        }
        dispatch({ type: "HIDE_LOADER" });
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        errorHandler(err, navigate)
      });
  };
  const onSubmit = async (s3LocationArr) => {
    const payload = {
      s3PathArr: s3LocationArr,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken"),
      userEmail: ls.get("email"),
    };
    dispatch({ type: "SHOW_LOADER" });
    const encryptedPayload = await encrypt(payload);
    axios
      .post(
        "/api/pms/finalSubmit",
        {
          payload: encryptedPayload,
        },
        {
          withCredentials: true,
        }
      )
      .then((data) => {
        if (data.data.status == true) {
          isPreviewClicked.current = false;
          setPreviewOpen(false);
          alert("Your file has been recorded.", "Shortly, You will receive an email update once all selected PMSs data is uploaded !", "success")
        } else {
          alert("Unable to Submit", "", "error")
        }
        dispatch({ type: "HIDE_LOADER" });
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        errorHandler(err, navigate);
      });
  };
  const handleFileUpload = async () => {
    dispatch({ type: "SHOW_LOADER" });
    isPreviewClicked.current = true;
    const formData = new FormData();
    const payload = {
      fy: selectedFinancialYear,
      quarter: selectedQuarter,
      permittedPMSs: ls.get("reportType")['Alert Processing']?.map(item => item.code)
    };
    const encryptedFormData = await encrypt(payload);
    formData.append("file", fileDetails);
    formData.append("fileName", fileName);
    formData.append("payload", encryptedFormData);

    const encryptedHeaders = await encrypt({
      authtoken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken")
    });

    axios
      .post("/api/pms/upload", formData, {
        withCredentials: true,
        headers: {
          headers: encryptedHeaders,
        },
      })
      .then((val) => {
        isPreviewClicked.current = false;
        if (val?.data?.success == true) {
          dispatch({ type: "HIDE_LOADER" });
          setUploadData(val?.data?.msg);
          setShowPreview(true);
          setPreviewOpen(true);
        } else if (val?.data?.success == "duplicates") {
          dispatch({ type: "HIDE_LOADER" });
          alert("Oops!", `${val.data.msg} files are already uploaded. Please remove duplicate files!!`, "error")
        } else if (val?.data?.success == false) {
          dispatch({ type: "HIDE_LOADER" });
          alert("Oops!", "Error in file upload. Please check with administrator!!", "error")
        }
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        isPreviewClicked.current = false;
        errorHandler(err, navigate)
      });
    setOpen(false);
  };

  const handlePreviewClick = async () => {
    if (!previewValidators(selectedFinancialYear, selectedQuarter, false, "", dispatch, "empty")) {
      return;
    }
    dispatch({ type: "SHOW_LOADER" });
    isPreviewClicked.current = true;
    const payload = {
      fy: selectedFinancialYear,
      quarter: selectedQuarter,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken")
    };
    const encryptedPayload = await encrypt(payload);
    axios
      .post(
        "/api/pms/fetchAlertStatus",
        { payload: encryptedPayload },
        {
          withCredentials: true,
        }
      )
      .then((data) => {
        if (data) {
          setRows(data.data.value);
          isPreviewClicked.current = false;
        } else {
          alert("Unable to fetch", "", "error")
        }
        dispatch({ type: "HIDE_LOADER" });
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        errorHandler(err, navigate)
      });
  };

  return (
    <>
      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate("/app/welcome")}
            >
              Welcome
            </Link>
            <Link underline="hover" color="inherit">
              Upload Utility
            </Link>
          </Breadcrumbs>
        </div>
        <div className={Styles.HeaderBody}>
          <div>
            <Grid container spacing={2} display="flex">
              <Grid item
                xs={12}
                sm={12}
                md={8}
                lg={9}>
                <SelectComponent
                  selectedFinancialYear={selectedFinancialYear}
                  setSelectedFinancialYear={setSelectedFinancialYear}
                  selectedQuarter={selectedQuarter}
                  setSelectedQuarter={setSelectedQuarter} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                className={Styles.dataFormButtonTracker}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "end",
                  gap: "2rem",
                }}
              >
                <div>
                  <button className={Styles.Preview} onClick={handleUpload}>
                    UPLOAD
                  </button>
                  {/* <ToastContainer /> */}
                  <div className={Styles.dialog_container}>
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="form-dialog-title"
                    >
                      <div className={Styles.detail_report_dailog}>
                        <p className={Styles.dailog_header}>Upload Details</p>
                        <div className={Styles.downloadable_format}>
                          <span>
                            " Please Upload the Mutltiple Files In ZIP "{" "}
                          </span>
                        </div>
                        <div className={Styles.upload_functionality}>
                          <UploadAction />
                        </div>
                        <div className={Styles.button_container}>
                          <button
                            className={Styles.Preview}
                            variant="contained"
                            color="secondary"
                            style={{ margin: "10px", color: "#ffffff", backgroundColor: fileName == "" && "#808080", cursor: fileName == "" && "initial", border: fileName == "" ? "0.125rem solid #808080" : "0.125rem solid #154063", }}
                            onClick={handleFileUpload}
                            disabled={fileName == "" ? true : false}
                          >
                            <span className={Styles.download_style}>
                              Apply
                            </span>
                          </button>
                          <button
                            className={Styles.cancel_button}
                            variant="contained"
                            color="secondary"
                            style={{ margin: "10px", color: "#ffffff" }}
                            onClick={handleClose}
                          >
                            <span className={Styles.download_style}>
                              Cancel
                            </span>
                          </button>
                        </div>
                      </div>
                    </Dialog>
                  </div>
                </div>
                <button className={Styles.Preview} onClick={handlePreviewClick}>
                  PREVIEW
                </button>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className={Styles.tableBody} style={{ position: "relative" }}>
          {isPreviewClicked.current == true && <Loader />}
          {rows.length > 0 && (
            <UploadTable
              receivedData={rows}
              disableBtn={disableBtn}
              setDisableBtn={setDisableBtn}
            />
          )}
          {isPreviewClicked.current == false && rows.length == 0 && (
            <img className="image" src={logo} alt="Group 1000000833.png" />
          )}
        </div>
        <>
          {showPreview ? (
            <Dialog
              open={previewOpen}
              onClose={handlePreviewClose}
              scroll={scroll}
              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
              fullWidth={true}
            >
              <DialogTitle id="scroll-dialog-title">PREVIEW</DialogTitle>
              <DialogContent dividers={scroll === "paper"}>
                <Grid xs={12} container spacing={3}>
                  <Grid item xs={4}>
                    SL No.
                  </Grid>
                  <Grid item xs={5}>
                    PMS NAME
                  </Grid>
                </Grid>
                {uploadData.map((item, i) => {
                  let filePath = item.s3Path.split(
                    `s3://${KEY.BUCKET}/PMS/ALERT/fileUpload/`
                  );
                  let fileName = filePath[1].split("/");
                  let pmsName = fileName[2].split(".");
                  s3LocationArr.push(item.s3Path);
                  return (
                    <Grid xs={12} container>
                      <Grid item xs={4}>
                        <Button
                          sx={{ "&:hover": { bgcolor: "#fff" }, color: "#000" }}
                        >
                          {i + 1}
                        </Button>
                      </Grid>
                      <Grid item xs={5}>
                        <Button
                          sx={{ "&:hover": { bgcolor: "#fff" }, color: "#000" }}
                        >
                          {pmsName[0]}
                        </Button>
                      </Grid>
                      <Grid xs={3}>
                        <button
                          className={Styles.Preview}
                          onClick={() => {
                            handelDownload(item.s3Path);
                          }}
                        >
                          Download
                        </button>
                      </Grid>
                    </Grid>
                  );
                })}
              </DialogContent>
              <DialogActions sx={{ marginRight: "3.5%" }}>
                <button
                  className={Styles.cancel_button}
                  onClick={handlePreviewClose}
                >
                  Cancel
                </button>
                <button
                  className={Styles.Preview}
                  onClick={() => {
                    onSubmit(s3LocationArr);
                  }}
                >
                  Submit
                </button>
              </DialogActions>
            </Dialog>
          ) : (
            <></>
          )}
        </>
      </div>
    </>
  );
};

export default SebiUploadUtility;
